import { Divider, Stack, Text, Title, useMantineTheme } from '@mantine/core'
import confetti from 'canvas-confetti'
import React, { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { saveLocation } from '@/plugins/auth/RouteRedirectors/utils'

import RootButton from '../../Buttons/RootButton'

interface ExtraInfoProps {
  itemName: string
  title: string
  description: string
  buttonText?: string
  buttonLink?: string
  templateId: string
}
const ExtraInfo: React.FC<ExtraInfoProps> = ({
  itemName,
  title,
  description,
  buttonText,
  buttonLink,
  templateId,
}) => {
  const theme = useMantineTheme()
  const navigate = useNavigate()

  const updateItemName = useCallback(
    () => description.replace('[Item Name]', itemName),
    [description, itemName]
  )
  return (
    <>
      <Title order={4}>{title}</Title>
      <Text style={{ color: theme.colors.paragraph[0] }}>{updateItemName()}</Text>
      {buttonText !== '' && buttonLink !== '' && (
        <RootButton
          secondary
          onClick={() => {
            saveLocation(buttonLink !== undefined ? `${buttonLink}` : `/spaces/${templateId}`)
            navigate(buttonLink !== undefined ? `${buttonLink}` : `/spaces/${templateId}`, {
              state: {
                myCreations: true,
              },
            })
          }}
        >
          {buttonText}
        </RootButton>
      )}
    </>
  )
}

interface CompletedStepperProps {
  itemName: string
  metadata: any
  templateId: string
}

const CompletedStepper: React.FC<CompletedStepperProps> = ({ itemName, metadata, templateId }) => {
  const completedStepperData = metadata.completedStepper
  const completedStepperRules = completedStepperData.rules
  const { mainTitle, mainDescription, extraInfo } = completedStepperRules

  useEffect(() => {
    confetti({
      particleCount: 1550,
      spread: 1400,
    })
    // launch a few confetti from the left edge
    confetti({
      particleCount: 117,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
    })
    // and launch a few from the right edge
    confetti({
      particleCount: 117,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
    })
  }, [])

  return (
    <Stack>
      <Divider />
      <Title order={3}>{mainTitle}</Title>
      <Stack style={{ textAlign: 'left', gap: '20px' }}>
        <Text>{mainDescription}</Text>
        {extraInfo.map((info: any) => (
          <ExtraInfo
            key={info.title}
            itemName={itemName}
            title={info.title}
            description={info.description}
            buttonText={info.buttonText}
            buttonLink={info?.buttonLink}
            templateId={templateId}
          />
        ))}
      </Stack>
    </Stack>
  )
}
export default CompletedStepper
